<div class="flex h-full">
  <section
    class="bg-[url(https://www.nysc.gov.ng/img/about-nysc-4.jpg)] bg-cover bg-center bg-no-repeat basis-2/5 hidden md:block">
    <div class="flex flex-col justify-center items-center h-[100dvh] bg-black bg-opacity-70">
      <p class="font-semibold tw-font-stretch-expanded text-3xl text-white text-center p-3">
        Find and post accommodations for NYSC corp members
      </p>
    </div>
  </section>

  <section class="flex flex-col justify-between basis-full md:basis-3/5">
    <div class="flex-1 flex flex-col justify-center gap-5 md:gap-7">
      <h2 class="text-center font-medium text-xl">Login</h2>

      <div #googleSignInButton
        class="w-64 mx-auto flex items-center justify-center [&>*]:w-full [&_#container-div]:w-full"
        id="google-signin-button"></div>

      <!-- Uncomment if we need to request access to their google drive and save uploads there -->
      <!-- <button type="button" (click)="askForGoogleAuth()">Try google again</button> -->


      <div class="flex my-0 mx-auto w-64 items-center justify-center gap-2">
        <mat-divider class="flex-1"></mat-divider>
        <span class="text-sm text-black">or<!--  a Prospective Corp Member? --></span>
        <mat-divider class="flex-1"></mat-divider>
      </div>

      <form class="grid my-0 mx-auto w-64 gap-2" [formGroup]="loginForm">
        <mat-form-field class="full-width" appearance="fill">
          <mat-label>State code or Email</mat-label>
          <input title="Email or NYSC state code" autocomplete="username" matInput formControlName="username"
            placeholder="" />
          <mat-error *ngIf="
              loginForm.controls['username'].hasError('minlength') &&
              !loginForm.controls['username'].hasError('required')
            ">
            Please enter a valid state code or email
          </mat-error>
          <mat-error *ngIf="loginForm.controls['username'].hasError('required')">
            State code or email is <strong>required</strong>
          </mat-error>
        </mat-form-field>

        <mat-form-field class="full-width" appearance="fill">
          <mat-label>Password</mat-label>
          <input #passwordInput matInput autocomplete="current-password" type="password" formControlName="password"
            placeholder="Minimum of 6 characters" />
          <button matSuffix mat-icon-button type="button"
            aria-label="Toggle password visibility" (click)="togglePasswordInputIcon()">
            <mat-icon>{{ passwordInputIcon }}</mat-icon>
          </button>
          <mat-hint align="start">Minimum of 6 characters</mat-hint>
          <mat-error *ngIf="
              loginForm.controls.password.hasError('minlength') &&
              !loginForm.controls.password.hasError('required')
            ">
            Please exceed 6 characters
          </mat-error>
          <mat-error *ngIf="loginForm.controls['password'].hasError('required')">
            Password is <strong>required</strong>
          </mat-error>
        </mat-form-field>

        <div class="text-right -mt-1">
          <a routerLink="/forgot-password" class="text-sm underline text-primary hover:text-primary-dark transition-colors">Forgot password?</a>
        </div>

        <app-progress-button type="submit" class="mt-6" (click)="login()"
          buttonText="Login" [loading]="isLoggingIn"
          [disabled]="loginForm.invalid || isLoggingIn"></app-progress-button>
      </form>


    </div>

    <div class="text-center mb-[2%]">
      Don't have an account?
      <a class="underline text-primary hover:text-primary-dark transition-colors" routerLink="/signup" queryParamsHandling="preserve">Sign up</a>.
    </div>
  </section>
</div>